/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Row, Col } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/base/Button';

interface UpdataNonVariationTableProps {
  setOpenUpdateVariataion: (show: boolean) => void;
  variationFormData?: any;
  selectedUpdateVariationId?: any;
  setVariationFormData?: any;
}

const UpdataNonVariationTable = ({
  setOpenUpdateVariataion,
  variationFormData,
  selectedUpdateVariationId,
  setVariationFormData
}: UpdataNonVariationTableProps) => {
  const { t } = useTranslation();

  const { register, reset, getValues } = useForm();

  //Get by id
  const fetchData = useMemo(() => {
    return () => {
      if (selectedUpdateVariationId === '') return console.log('NO id');

      const computed = variationFormData?.map((el: any) => {
        return {
          variation: el?.product,
          barcode: el?.var_barcode,
          vendor_code: el?.vendor_code,
          party_number: el?.party_number,
          code: el?.code
        };
      });

      reset(computed[selectedUpdateVariationId]);
    };
  }, [selectedUpdateVariationId]);

  // console.log('variationFormData====>', variationFormData);

  const onSubmit = () => {
    const data = getValues();

    if (selectedUpdateVariationId !== '') {
      const updatedFormData = [...variationFormData];
      updatedFormData[selectedUpdateVariationId] = {
        // ...updatedFormData[selectedUpdateVariationId],
        var_data: updatedFormData[selectedUpdateVariationId].var_data,
        nomenclature_id: updatedFormData[selectedUpdateVariationId]
          .nomenclature_id
          ? updatedFormData[selectedUpdateVariationId].nomenclature_id
          : undefined,
        nomenclature_pid: updatedFormData[selectedUpdateVariationId]
          .nomenclature_pid
          ? updatedFormData[selectedUpdateVariationId].nomenclature_pid
          : undefined,
        product: data?.variation,
        var_barcode: data?.barcode,
        vendor_code: data.vendor_code,
        party_number: data.party_number,
        code: data.code
      };

      setVariationFormData([...updatedFormData]);
      setOpenUpdateVariataion(false);
    }
  };

  useEffect(() => {
    if (selectedUpdateVariationId !== '') {
      fetchData();
    }
  }, [selectedUpdateVariationId]);

  return (
    <div>
      <Form noValidate>
        <Row className="mb-2">
          <Col>
            <Form.Floating className="md-4">
              <Form.Control
                {...register('variation')}
                type="text"
                placeholder={t('variation')}
                onFocus={e => e.target.select()}
              />
              <label htmlFor="floatingInputCustom">{t('variation')}</label>
            </Form.Floating>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Floating className="md-4">
              <Form.Control
                {...register('barcode')}
                type="text"
                placeholder={t('barcode')}
                onFocus={e => e.target.select()}
              />
              <label htmlFor="floatingInputCustom">{t('barcode')}</label>
            </Form.Floating>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Floating className="md-4">
              <Form.Control
                {...register('vendor_code')}
                type="text"
                placeholder={t('article')}
                onFocus={e => e.target.select()}
              />
              <label htmlFor="floatingInputCustom">{t('article')}</label>
            </Form.Floating>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Floating className="md-4">
              <Form.Control
                {...register('party_number')}
                type="text"
                placeholder={t('party_number')}
                onFocus={e => e.target.select()}
              />
              <label htmlFor="floatingInputCustom">{t('party_number')}</label>
            </Form.Floating>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Floating className="md-4">
              <Form.Control
                {...register('code')}
                type="text"
                placeholder={t('ikpu_code')}
                onFocus={e => e.target.select()}
              />
              <label htmlFor="floatingInputCustom">{t('ikpu_code')}</label>
            </Form.Floating>
          </Col>
        </Row>

        <Button className="w-100" variant="primary" onClick={onSubmit}>
          {t('save')}
        </Button>
      </Form>
    </div>
  );
};

export default UpdataNonVariationTable;
